const fromdata = [
	{
	  inputdata: '',
	  title: '用户名',
	  fontSize: '14px',
	  color: '#333333',
	  placeholder: '请输入',
	  types: 'text',
	  inputtype: 'input',
	  width: '190px'
	},
	{
	  inputdata: '',
	  title: '姓名',
	  fontSize: '14px',
	  color: '#333333',
	  placeholder: '请输入',
	  types: 'text',
	  inputtype: 'input',
	  width: '190px',
	  lablewith: '98px'
	},
	{
		inputdata: "",
		title: "操作日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "",
		inputtype: "date",
		width: "140px",
		lablewith: '108px'
	  },
  ]
export default fromdata; 

